import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {TaskApprovalStatusType} from "../../types/taskApprovalStatus.type";

export class TaskApprovalStatusMultiSelectListComponent implements IController {
  approvalStatuses: any;
  options: any;
  ngPlaceholder: any;
  onChange: Function;

  private selectedKeys: any;
  private queryString: any;

  constructor() {
  }

  $onInit() {
    if (!this.options || !this.options.length) {
      this.options = Object.values(TaskApprovalStatusType);
    }
  }

  $onChanges(changes) {
    if (changes.approvalStatuses) {
      this.selectedKeys = [];
      _.forEach(this.approvalStatuses, (type) => {
        this.selectedKeys[type] = true;
      })
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onToggle(option, isSelected) {
    this.onChange({
      approvalStatuses: isSelected ? _.concat(this.approvalStatuses, [option]) :
        _.filter(this.approvalStatuses, (type) => {
          return type !== option;
        })
    });
  }


  submitQuery(query) {
    this.queryString = query;
  }

  onReset() {
    this.onChange({approvalStatuses: []});
  }

}

angular
  .module('bringoz.admin.tasks')
  .component('taskApprovalStatusMultiSelectList', {
    bindings: {
      approvalStatuses: '<',
      options: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./task-approval-status-multi-select-list.html').default,
    controller: TaskApprovalStatusMultiSelectListComponent
  });

